<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="">
            Youtube
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="">
            Blog
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="">
            Facebook
          </a>
        </li>
      </ul>
      <div class="copyright">
        © {{year}} made with <i class="tim-icons icon-heart-2"></i> by
        <a href="" target="_blank" rel="noopener">alisano.com</a>&nbsp;
        for a better life.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
